import React from "react";
import IconAszdziennik from "../../../../assets/img/aszdziennik/dociekliwosc_dziennikarska_asz.svg"

import AttachmentContentBase from "../../../../redesign/components/AttachmentBase";
import { AttachmentElement } from "../../../../components/Article/Parts/Slate/types"


type AttachmentProps = {
    element: AttachmentElement;
};

const AttachmentContent: React.FC<AttachmentProps> = ({
    element,
}) => {

    return (
        <AttachmentContentBase element={element} icon={IconAszdziennik} />
    );
};

export default AttachmentContent;
